import { Box, Card, Typography } from '@mui/material'
import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { PageContext } from '../../contexts/PageContext';
import styled from 'styled-components'
import { PATHS } from '../../utils/constant';
import { AuthContext } from '../../contexts/AuthContext';

const CardsData = [
    {
        label: 'GMS',
        img_path: 'assets/icons/GMS_CARD_ICON.svg',
        link: PATHS.GMS
    },
    {
        label: 'Buy & Sell',
        img_path: 'assets/icons/BUYSELL_CARD_ICON.svg',
        link: PATHS.BUY_SELL
    },
    {
        label: 'Job Work',
        img_path: 'assets/icons/JOBWORK_CARD_ICON.svg',
        link: PATHS.JOB_WORK
    },
    {
        label: 'Purity Testing',
        img_path: 'assets/icons/PURITYTESTING_CARD_ICON.svg',
        link: PATHS.PURITY_TESTING
    },
    {
        label: 'Buy Back',
        img_path: 'assets/icons/BUYBACK_CARD_ICON.svg',
        link: PATHS.BUY_BACK
    },
    {
        label: 'Minted Sales',
        img_path: 'assets/icons/MINTEDSALES_CARD_ICON.svg',
        link: PATHS.MINTED_SALES
    },
    {
        label: 'Redeem at PVC',
        img_path: 'assets/icons/MINTEDSALES_CARD_ICON.svg',
        link: PATHS.REDEEM_AT_PVC_TRANSACTION
    },
]

const MainStyledIconContainer = styled(Box)(({ theme }) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: '30px',
}));


const StyledCard = styled(Card)`
    width: 100%;
    height: 96px;
    padding: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    /* background-image: url('logo512.png'); */
    &:hover {
        box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
    }
`

const StyledImg = styled('img')(({ theme }) => ({
    width: '56px',
    height: '56px',
}));

const CreateTransaction=()=> {
    const { setPageState } = useContext(PageContext)
    const { user } = useContext(AuthContext)

    useEffect(() => {
        setPageState({
            title: 'Home',
            currentPage: 'home',
            breadcrumbs: [],
            path: PATHS.CREATE_TRANSACTION
        })
    }, [])

    const isPlantPVC = user?.isPlantPvc!

    return (
        <MainStyledIconContainer >
            {
                CardsData.map((data) => {
                    if(isPlantPVC && data.link === PATHS.JOB_WORK){
                        return
                    }
                    return (
                        <Link key={data.label} to={data.link!} style={{ width: '30%', textDecoration: 'none' }}>
                            <StyledCard elevation={3}>
                                <StyledImg src={data.img_path} alt={data.label} />
                                <Typography sx={{
                                    fontSize: '23px',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    padding: '10px'
                                }}>{data.label}</Typography>
                            </StyledCard>
                        </Link>
                    )
                })
            }

        </MainStyledIconContainer>
    )
}

export default CreateTransaction